import {BrowserModule} from "@angular/platform-browser"
import {NgModule} from "@angular/core"

import {AppRoutingModule} from "app/AppRoutingModule"
import {AppComponent} from "app/AppComponent"
import {BrowserAnimationsModule} from "@angular/platform-browser/animations"
import {LayoutModule} from "@angular/cdk/layout"
import {MaterialModule} from "app/common/material/MaterialModule"
import {LoginModule} from "app/login/LoginModule"
import {HttpModule} from "app/common/services/http/HttpModule"
import {ErrorServiceModule} from "app/common/services/error/ErrorServiceModule"
import {ConfirmationServiceModule} from "app/common/services/confirmation/ConfirmationServiceModule"

@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        LayoutModule,
        MaterialModule,
        LoginModule,
        HttpModule,
        ErrorServiceModule,
        ConfirmationServiceModule
    ],
    providers: [],
    bootstrap: [AppComponent]
})
export class AppModule {
}
